import api from './api';

export default {
  getAll() {
    return api.get('/translate-price-tiers');
  },
  getById(id: number) {
    return api.get(`/translate-price-tiers/${id}`);
  },
  create(data: object) {
    return api.post('/translate-price-tiers', data);
  },
  update(id: number, data: object) {
    return api.put(`/translate-price-tiers/${id}`, data);
  },
  delete(id: number) {
    return api.delete(`/translate-price-tiers/${id}`);
  }
};
